import './assets/styles/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import consoleDebug from './plugins/vue-plugin-console-debug'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(consoleDebug)

app.mount('#app')
